import React, { useState } from 'react'
import { withPrefix } from 'gatsby'
import { FaClock } from 'react-icons/fa'
import s from './rapidEstimatorForm.module.css'
import { ArrowTop } from '../../../svg/arrow_top'
import { calculatedBirthDate } from '../../../lib/date'
import { GTMEvents } from '../../../lib/GTMevents'
import { headerData } from '../../../constants/dataCalculateProjection'
import { Modal } from '../../modal/modal'
import { Radio } from '../../forms/forms'
import { stripNonNumbers, numberWithCommas } from '../../../lib/numbers'
import api, { SERVICE_URL_ESTIMADOR, CONFIG } from '../../../api/api'
import Btn from '../../buttons/buttons'

const RapidEstimatorForm = () => {
  /* FORM ESTIMADOR RAPIDO */
  const EMPTY_RESPONSE = {
    pension: [{ monto: 0 }],
    saldoFuturo: 0,
  }

  const MIN_AGE = 18
  const MAX_AGE = 120

  const [sexo, setSexo] = useState('')
  const [edad, setEdad] = useState('')
  const [fondo, setFondo] = useState('')
  const [sueldo, setSueldo] = useState('')
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [response, setResponse] = useState(EMPTY_RESPONSE)

  const onChangeFechaNacimiento = evt => {
    const { value, maxLength } = evt.target
    if (isNaN(parseFloat(value))) {
      // No es númerp
      setEdad('')
    } else {
      const newValue = value.slice(0, maxLength)
      setEdad(newValue)
    }
  }

  function sendInfoProjection(initData, formData) {
    setLoading(true)
    const newHeaderData = { ...initData, ...formData }
    api
      .post(SERVICE_URL_ESTIMADOR, newHeaderData, CONFIG)
      .then(response => {
        if (response.data) {
          setLoading(false)
          setResponse(response.data)
          GTMEvents.BtnCalculatePension(sexo, 'exitoso')
        } else {
          setLoading(false)
          setErrorMessage('Error en la respuesta')
          GTMEvents.BtnCalculatePension(sexo, 'Error en la respuesta')
          setShowModal(true)
        }
      })
      .catch(error => {
        setLoading(false)
        setErrorMessage('Ocurrió un error al realizar la petición')
        setShowModal(true)
        GTMEvents.BtnCalculatePension(
          sexo,
          'Ocurrió un error al realizar la petición'
        )
        console.log('error ->', error)
      })
  }

  function setSueldoMensual(evt) {
    setSueldo(numberWithCommas(stripNonNumbers(evt.target.value)))
  }

  function setSaldoActual(evt) {
    setFondo(numberWithCommas(stripNonNumbers(evt.target.value)))
  }

  function calculateProjection() {
    if (!sexo) {
      setErrorMessage('Sexo es campo requerido')
      setShowModal(true)
      GTMEvents.BtnCalculatePension(sexo, 'Error - Sexo es campo requerido')
      return
    }

    if (!sueldo) {
      setErrorMessage('Sueldo mensual es un campo requerido')
      setShowModal(true)
      GTMEvents.BtnCalculatePension(
        sexo,
        'Error - Sueldo mensual es un campo requerido'
      )
      return
    } else if (sueldo * 1 < 1025) {
      setErrorMessage('Ingresa un monto igual o mayor a S/ 1025')
      GTMEvents.BtnCalculatePension(
        sexo,
        'Error - Ingresa un monto igual o mayor a S/ 1025'
      )
      setShowModal(true)
      return
    }

    if (!edad) {
      setErrorMessage('Edad es un campo requerido')
      setShowModal(true)
      setEdad('')
      GTMEvents.BtnCalculatePension(sexo, 'Error - Edad es un campo requerido')
      return
    } else if (edad * 1 < MIN_AGE || edad * 1 > MAX_AGE) {
      setErrorMessage('Ingresa una edad igual o mayor a 18 años.')
      setShowModal(true)
      setEdad('')
      GTMEvents.BtnCalculatePension(
        sexo,
        'Error - Ingresa una edad igual o mayor a 18 años.'
      )
      return
    }

    if (!fondo) {
      setErrorMessage('Fondo es un campo requerido')
      setShowModal(true)
      GTMEvents.BtnCalculatePension(sexo, 'Error - Fondo es un campo requerido')
      return
    }

    setResponse(EMPTY_RESPONSE)
    const formData = {
      fechaNacimiento: calculatedBirthDate(edad),
      sexo: sexo === 'Hombre' ? 'H' : 'M',
      saldoNoAfecto: stripNonNumbers(fondo),
      promedioRemuneraciones: stripNonNumbers(sueldo),
      remuneracionActual: stripNonNumbers(sueldo),
    }
    sendInfoProjection(headerData, formData)
  }

  function elegirGenero(evt) {
    setSexo(evt.target.value)
    setEdad('')
    setFondo('')
    setSueldo('')
    setResponse(EMPTY_RESPONSE)
  }
  /* FIN ESTIMADOR RAPIDO */

  return (
    <>
      <section className="tw-py-0 tw-py-12@lg bg-white bg-gray--13@lg">
        <div className="containerWrap">
          <div className="brad-4 bg-white border-gray-3 tw-px-20@lg tw-py-18@lg flex direction-column direction-row@lg border-0 border-1@lg">
            <div className={`w-100 tw-mb-12 db dn@lg`}>
              <h2 className="font-family-secondary tw-f-24 tw-f-32@lg center left@lg tw-mt-6 tw-mb-4 tw-pr-16@lg">
                Calcula tu pensión ideal
              </h2>
              <div
                className={`font-family-primary tw-f-16 center left@lg tw-pr-6@lg`}
              >
                Ingresando los datos correspondientes puedes estimar la pensión
                que obtendrías a partir de los 65 años.
              </div>
            </div>

            <div
              className={`w-100 w-60@lg order-2 order-1@lg tw-mb-14 tw-mb-0@lg`}
            >
              <div className={`flex direction-column tw-px-10@lg`}>
                {/*SEXO*/}
                <div className="flex justify-between tw-mb-6 w-100">
                  <div className="flex items-center border-1 border-gray-3 brad-3 tw-px-4 tw-py-3 w-45">
                    <Radio
                      name="sexo"
                      label="Hombre"
                      value="hombre"
                      className="db tw-f-16 font-family-primary fw-0 tw-mb-0 justify-between w-100 direction-row-reverse"
                      checked={sexo === 'hombre'}
                      onChange={elegirGenero}
                    />
                  </div>
                  <div className="flex items-center border-1 border-gray-3 brad-3 tw-px-4 tw-py-3 w-45">
                    <Radio
                      name="sexo"
                      label="Mujer"
                      value="mujer"
                      className="db tw-f-16 font-family-primary fw-0 tw-mb-0 justify-between w-100 direction-row-reverse"
                      checked={sexo === 'mujer'}
                      onChange={elegirGenero}
                    />
                  </div>
                </div>

                {/*FECHA*/}
                <div className="tw-mb-6">
                  <label
                    htmlFor="fechaNacimiento"
                    className="db tw-f-14 font-family-primary fw-0 c-gray--6"
                  >
                    ¿Cuantos años tienes?
                  </label>
                  <div className="border-1 border-gray-3 brad-3 tw-px-4 tw-py-3 relative">
                    <input
                      id="fechaNacimiento"
                      name="fechaNacimiento"
                      type="text"
                      maxLength="2"
                      className={`${s.inputForm} w-100 z-10`}
                      value={edad}
                      onChange={e => onChangeFechaNacimiento(e)}
                    />
                  </div>
                </div>

                {/*MONTOS*/}
                <div className="flex direction-column direction-row@lg justify-between tw-mb-8 w-100">
                  <div className="flex direction-column w-100 w-45@lg tw-mb-6 tw-mb-0@lg">
                    <label
                      htmlFor="ingresoMensual"
                      className="db tw-f-14 font-family-primary fw-0 c-gray--6"
                    >
                      Ingreso mensual
                    </label>
                    <div className="flex direction-column border-1 border-gray-3 brad-3 tw-px-4 tw-py-3 w-100">
                      <input
                        id="ingresoMensual"
                        name="ingresoMensual"
                        type="text"
                        value={sueldo}
                        className={`${s.inputForm} ${s.inputForm_s} left tw-f-16 c-gray--1 font-family-primary fw-0 relative w-100 tw-pl-5`}
                        onChange={setSueldoMensual}
                      />
                      <span
                        className={`${s.fakeLine} tw-f-16 font-family-primary fw-0 c-gray--1`}
                      ></span>
                    </div>
                    <span className="db tw-f-14 font-family-primary fw-0 c-gray--6 tw-mt-2">
                      Sueldo sin descuentos
                    </span>
                  </div>

                  <div className="flex direction-column w-100 w-45@lg">
                    <label
                      htmlFor="inputSaldoActual"
                      className="db tw-f-14 font-family-primary fw-0 c-gray--6"
                    >
                      Saldo actual en tu fondo
                    </label>
                    <div className="flex direction-column border-1 border-gray-3 brad-3 tw-px-4 tw-py-3 w-100">
                      <input
                        id="inputSaldoActual"
                        name="inputSaldoActual"
                        type="text"
                        value={fondo}
                        className={`${s.inputForm} ${s.inputForm_s} left tw-f-16 c-gray--1 font-family-primary fw-0 relative w-100 tw-pl-5`}
                        onChange={setSaldoActual}
                      />
                      <span
                        className={`${s.fakeLine} tw-f-16 font-family-primary fw-0 c-gray--1`}
                      ></span>
                    </div>
                  </div>
                </div>

                {/* BOTONERA */}
                <div>
                  <Btn
                    type="button"
                    label={
                      loading ? (
                        <span>
                          <FaClock className="f-0" /> Calculando...
                        </span>
                      ) : (
                        'Calcular pensión'
                      )
                    }
                    className="tw-f-18 tw-py-3 tw-px-14"
                    size="big"
                    onClick={calculateProjection}
                    disabled={loading}
                  />
                </div>
              </div>
            </div>

            {response.pension[0].monto > 0 ? (
              <div
                className={`w-100 w-40@lg tw-py-6 tw-px-4 tw-pt-0@lg tw-pl-12@lg tw-pr-8@lg tw-pb-0@lg order-3 order-2@lg bg-gray--13 bg-white@lg brad-4 brad-0@lg`}
              >
                <div className={`${s.result}`}>
                  <p className="font-family-primary fw-0 tw-f-16 tw-f-16@lg tw-mb-2">
                    Pensión estimada
                  </p>
                  <p className="font-family-secondary fw-7 tw-f-36 tw-f-36@lg tw-mb-3">
                    S/{numberWithCommas(response.pension[0].monto)}
                  </p>

                  <div className="bg-white flex direction-column border-1 border-orange-0 brad-4 tw-px-6 tw-py-4 tw-mb-0">
                    <p className="flex items-center c-gray--4 font-family-primary fw-0 tw-f-16 tw-f-16@lg tw-mb-4">
                      <img
                        src={withPrefix('/images/ico-chart-orange.svg')}
                        alt=""
                        className={`${s.ico} tw-mr-2`}
                      />
                      Fondo estimado
                    </p>
                    <p className="c-gray--4 font-family-secondary fw-7 tw-f-24 tw-f-24@lg tw-mb-0">
                      S/ {numberWithCommas(response.saldoFuturo)}
                    </p>
                  </div>
                  <div className="flex justify-center">
                    <ArrowTop fill={'45494E'} className={`${s.icoArrow} db`} />
                  </div>
                  <div className="bg-white flex direction-column border-1 border-gray-0 brad-4 tw-px-6 tw-py-4 tw-mb-4">
                    <p className="flex items-center c-gray--4 font-family-primary fw-0 tw-f-16 tw-f-16@lg tw-mb-4">
                      <img
                        src={withPrefix('/images/ico-dollar-green.svg')}
                        alt=""
                        className={`${s.ico} tw-mr-2`}
                      />
                      Saldo actual de tu fondo
                    </p>
                    <p className="c-gray--4 font-family-secondary fw-7 tw-f-24 tw-f-24@lg tw-mb-0">
                      S/{' '}
                      {numberWithCommas(
                        document.querySelector('input[name="inputSaldoActual"]')
                          .value
                      )}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={`w-100 w-40@lg tw-p-0 tw-pb-12 tw-p-10@lg tw-pr-0@lg order-1 order-2@lg dn db@lg`}
              >
                <img
                  src={withPrefix('/images/ico-dedo.svg')}
                  alt=""
                  className={`${s.icoDedo} tw-mb-2 dn db@lg`}
                />
                <h2 className="font-family-secondary tw-f-24 tw-f-32@lg center left@lg tw-mt-0 tw-mb-4 tw-pr-16@lg">
                  Calcula tu pensión ideal
                </h2>
                <div
                  className={`font-family-primary tw-f-16 center left@lg tw-pr-6@lg`}
                >
                  Ingresando los datos correspondientes puedes estimar la
                  pensión que obtendrías a partir de los 65 años.
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* MODAL VALIDACION/MSG ESTIMADOR RAPIDO */}
      {showModal && (
        <Modal
          addBottomCLose={false}
          stickAtTop={false}
          removePadding={false}
          size={'small'}
          onCloseRequest={() => {
            setShowModal(false)
          }}
        >
          <>
            {!sexo || !sueldo || !edad || !fondo ? '' : <h3>Error</h3>}
            <p>{errorMessage}</p>
          </>
        </Modal>
      )}
      {/* MODAL VALIDACION/MSG ESTIMADOR RAPIDO */}
    </>
  )
}

export default RapidEstimatorForm
